import {Splitter} from "@mytour/ui/layout";
import {Badge, Button} from "reactstrap";

type Props = {
  onRegister: (type: "monthly" | "yearly") => void;
};

export function DefaultPrice({onRegister}: Props) {
  return (
    <Splitter>
      <div style={{width: "100%", height: "100%"}}>
        <Button
          style={{width: "100%", height: "100%"}}
          onClick={handleMonthlyClick}
          color="primary"
        >
          <div style={{textAlign: "center"}}>
            <h4>20€ / mois</h4>
            <p>
              Une offre <b>flexible</b>
              <br />
              sans engagement
            </p>
          </div>
        </Button>
      </div>
      <div style={{width: "100%", height: "100%"}}>
        <Button
          style={{width: "100%", height: "100%"}}
          onClick={handleYearlyClick}
          color="primary"
        >
          <div style={{textAlign: "center"}}>
            <h4>
              <span className="strikethrough-diagonal">240€</span> / an
            </h4>
            <p>
              <Badge
                color="light"
                pill
                style={{
                  color: "var(--mt-color-action)",
                  padding: "0.25em 0.15em",
                  fontSize: "20px",
                  marginRight: "4px",
                }}
              >
                -17%
              </Badge>
              soit 200€ / an
              <br />
              Un tarif <b>avantageux</b>
            </p>
          </div>
        </Button>
      </div>
    </Splitter>
  );

  function handleMonthlyClick() {
    onRegister("monthly");
  }

  function handleYearlyClick() {
    onRegister("yearly");
  }
}
